var map = {
	"./fish1.png": "WPGz",
	"./fish10.png": "TeMu",
	"./fish11.png": "echE",
	"./fish12.png": "Bd8W",
	"./fish13.png": "6Pje",
	"./fish14.png": "5kQw",
	"./fish15.png": "XT5X",
	"./fish16.png": "nW8e",
	"./fish17.png": "EdCt",
	"./fish18.png": "syHL",
	"./fish19.png": "sQFV",
	"./fish2.png": "q9A3",
	"./fish20.png": "u1dG",
	"./fish21.png": "btZw",
	"./fish26.png": "e0+g",
	"./fish27.png": "1iTy",
	"./fish28.png": "/oJU",
	"./fish29.png": "WkAL",
	"./fish3.png": "NawE",
	"./fish30.png": "TDsO",
	"./fish31.png": "1bv8",
	"./fish32.png": "46tj",
	"./fish33.png": "S5Vs",
	"./fish34.png": "NLFK",
	"./fish35.png": "C1/m",
	"./fish36.png": "MyBn",
	"./fish37.png": "5bdB",
	"./fish38.png": "9LSa",
	"./fish39.png": "Wmlv",
	"./fish4.png": "xT1A",
	"./fish40.png": "b+B6",
	"./fish41.png": "rjZn",
	"./fish42.png": "1x2r",
	"./fish43.png": "Pvlj",
	"./fish44.png": "7OSN",
	"./fish45.png": "+3cV",
	"./fish46.png": "cZqs",
	"./fish47.png": "2B3A",
	"./fish48.png": "cse9",
	"./fish5.png": "X6St",
	"./fish6.png": "0aEO",
	"./fish7.png": "1q0x",
	"./fish8.png": "r4Tk",
	"./fish9.png": "GEky"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wktk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish ^\.\/fish.*\.png$
// module id = wktk
// module chunks = 0